<template>
  <div>
    <q-select
      label="Prefill Action Description (Warning, this will clear the Action Description)"
      v-model="actionTemplate"
      :options="actionTemplates"
      option-label="name"
      @input="prefillActionDescription"
    >
    </q-select>
    <q-form ref="actionForm">
      <q-input
        v-model="actionFormData.description"
        label="Action Description"
        type="textarea"
        :rules="[(v) => !!v || 'Field is Required']"
      >
      </q-input>
      <q-btn
        v-if="isCreate"
        color="primary"
        @click="create"
        class="float-right q-mt-sm"
        :disable="disable"
      >
        <q-icon name="mdi-plus-circle" class="q-mr-sm"> </q-icon>
        <span class="sustainability-font q-mx-sm" style="font-size: 13px">
          Create
        </span>
      </q-btn>
      <q-btn
        v-else
        color="primary"
        @click="save"
        class="float-right q-mt-sm"
        :disable="disable"
      >
        <q-icon name="mdi-plus-circle" class="q-mr-sm"> </q-icon>
        <span class="sustainability-font q-mx-sm" style="font-size: 13px">
          Save
        </span>
      </q-btn>
    </q-form>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    props: {
      disable: {
        type: Boolean,
        default: false,
      },
      solutionTitle: {
        type: String,
        default: "",
      },
    },
    computed: {
      ...mapGetters({
        data: "solutions/actions/selectedAction",
        actionTemplates: "actionTemplates/list",
      }),
    },

    data: () => ({
      actionFormData: {},
      isCreate: true,

      actionTemplate: null,
    }),
    watch: {
      $route: {
        handler() {
          this.init();
        },
        deep: true,
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      async init() {
        if (this.$route.params.hasOwnProperty("actionsID")) {
          await this.$store.dispatch(
            "solutions/actions/loadActionByID",
            this.$route.params.actionsID
          );

          this.actionFormData = JSON.parse(JSON.stringify(this.data));
          this.isCreate = false;
        }
      },
      async create() {
        const isValid = await this.$refs.actionForm.validate();
        if (isValid) {
          let result = await this.$store.dispatch("solutions/actions/new", {
            ...this.actionFormData,
            solutions_id: this.$route.params.id,
          });

          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });

            this.actionFormData = {
              description: "",
            };
            await this.$refs.actionForm.reset();
            this.closeForm();
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      async save() {
        const isValid = await this.$refs.actionForm.validate();
        if (isValid) {
          let result = await this.$store.dispatch("solutions/actions/save", {
            ...this.actionFormData,
            solutions_id: this.$route.params.id,
          });
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            this.actionFormData = {
              description: "",
            };
            await this.$refs.actionForm.reset();
            this.closeForm();
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      prefillActionDescription() {
        let text = JSON.parse(JSON.stringify(this.actionTemplate));
        this.actionFormData.description = text.templateValue.replaceAll(
          "-solutionTitle-",
          this.solutionTitle
        );
      },
      closeForm() {
        this.$emit("closeForm");
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
